/**
 * CPV-MT-01 F1 · the header location choice, outside React, so `utils/api.js` can add it to every CPV request.
 *
 * ScopeContext writes it (after the organisation tree and the saved preference are read); the request interceptor reads
 * it. Nothing here decides who may see what: the server intersects whatever is sent with the caller's reach.
 *
 *   setScopeParams(params)   {plant: 'all' | '1,2'} or {} (one readable plant: nothing is sent, the server's default)
 *   scopeParamsFor(config)   the params to add to one Axios request config, or null
 */
export const PLANT_KEY = 'plant';
/** The CPV API prefixes the selector applies to (the CPV screens and the CPV assistant); every other request is left as it is. */
const CPV_PATH = /(^|\/)bp\/cpv(-ai)?\//;

let current = {};

export const setScopeParams = (params) => { current = { ...(params || {}) }; };
export const getScopeParams = () => current;

/** The scope params for a CPV GET that names no scope of its own (a list's own plant filter wins). */
export function scopeParamsFor(config) {
  if (!config || String(config.method || 'get').toLowerCase() !== 'get') return null;
  if (!CPV_PATH.test(String(config.url || ''))) return null;
  if (!Object.keys(current).length) return null;
  // a request naming its own plant (a list's filter, a record's plant) keeps it; `site` is not a scope key on CPV calls
  // (master/picker/?site= names the site master), so only `plant` is checked and only `plant` is sent
  const own = config.params || {};
  if (own[PLANT_KEY] !== undefined && own[PLANT_KEY] !== null && own[PLANT_KEY] !== '') return null;
  return current;
}
